import appConfig from "./appConfig";

function removeProtocol(url: string): string {
    const parts = url.split("//");

    if (parts.length === 2) {
        return parts[1];
    }

    return url;
}

function getEnvironmentName(): string {
    const { registrationServiceUrl } = appConfig();

    const parts = removeProtocol(registrationServiceUrl).split("-");

    if (parts.length === 2) {
        return parts[0];
    }

    return "production"; //only environment without a '-' in the service URL
}

export default getEnvironmentName;
